import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';

const CheckCircleIcon = () => (
  <svg
    className="w-14 h-14 text-green-400 mx-auto mb-5"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={1.8}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

const XCircleIcon = () => (
  <svg
    className="w-14 h-14 text-red-400 mx-auto mb-5"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={1.8}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

const StatusRow = ({ label, value, color }) => (
  <div className="flex items-center justify-between gap-4 border-b border-white/10 py-3 last:border-0">
    <span className="text-sm text-slate-400">{label}</span>
    <span className={`text-sm font-semibold ${color}`}>{value}</span>
  </div>
);

const OnboardSuccess = () => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status');
  const pageName = searchParams.get('page_name') || 'Selected Meta assets';

  const isSuccess = status === 'success';

  return (
    <div className="min-h-screen ccc-operator-hero flex items-center justify-center px-4 py-20 text-white">
      <div className="w-full max-w-lg">
        <p className="ccc-kicker mb-5">Meta authorization</p>

        {isSuccess ? (
          <section className="ccc-dossier p-7 text-center">
            <CheckCircleIcon />
            <h1 className="text-2xl font-black text-white mb-2">Authorization received</h1>
            <p className="text-green-400 font-bold text-base mb-7">{pageName}</p>

            <div className="bg-black/20 rounded-md p-4 mb-6 text-left">
              <p className="ccc-dossier-label mb-2">Connection status</p>
              <StatusRow label="WhatsApp Business" value="Authorized" color="text-green-400" />
              <StatusRow label="Facebook Page" value="Connected" color="text-green-400" />
              <StatusRow label="Instagram Business" value="Connected" color="text-green-400" />
              <StatusRow label="Ad Reporting" value="Enabled" color="text-green-400" />
            </div>

            <p className="text-sm leading-relaxed text-slate-400">
              The connection is recorded. Crespo Cyber Consulting LLC will review
              the approved assets and continue setup from the authorized scope.
            </p>
          </section>
        ) : (
          <section className="ccc-dossier p-7 text-center">
            <XCircleIcon />
            <h1 className="text-2xl font-black text-white mb-3">Authorization not completed</h1>
            <p className="text-sm leading-relaxed text-slate-400 mb-7">
              The Meta connection did not finish. This usually means the approval
              was cancelled or one of the requested permissions was denied.
            </p>
            <Link
              to="/onboard"
              className="ccc-primary-btn w-full py-3 text-base"
            >
              Try again
            </Link>
          </section>
        )}
      </div>
    </div>
  );
};

export default OnboardSuccess;
